export enum ConversationMessageAttachmentContentType {
    None = 0,
    Image = 1,
    Pdf = 2,
}
